<template>
  <el-dialog
    title="详情列表"
    custom-class="lineHeader"
    :visible.sync="options.visible"
    v-loading="vLoading"
    width="80%">
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="id"
          min-width="180"
          label="账单ID">
        </el-table-column>
        <el-table-column
            prop="createTime"
            min-width="160"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="dropOffPlatform"
            min-width="108"
            label="Platform">
        </el-table-column>
        <el-table-column
            prop="pickUpNo"
            min-width="160"
            label="运单号">
        </el-table-column>
        <el-table-column
            prop="pickupTime"
            min-width="160"
            label="揽件时间">
          <template slot-scope="scope">
            <span v-if="scope.row.pickupTime">{{ scope.row.pickupTime}}</span>
            <span v-if="!scope.row.pickupTime">-</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="billName"
            min-width="160"
            label="账单类型">
        </el-table-column>
        <el-table-column
            prop="amount"
            min-width="108"
            label="金额">
        </el-table-column>
        <el-table-column
            prop="balance"
            min-width="156"
            label="账户余额">
        </el-table-column>
        <el-table-column
            prop="remark"
            min-width="120"
            show-overflow-tooltip
            label="备注">
        </el-table-column>
      </el-table>
      <el-pagination class="mt-10" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pagination.pageIndex" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 200]" :total="pagination.total">
        </el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="options.visible = false" round>关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment"
import {queryDetailList} from "@/api/dropOff";
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          visible: false,
          width: '1200px'
        }
      }
    }
  },
  data() {
    return {
      tableData: [],
      vLoading: false,
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
    }
  },
  watch: {
    'options.visible' : {
      handler(val) {
        if (val) this.initDetail()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    /*日期处理*/
    dateFormat(row) {
      var date = new Date(row)
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if(month > 12){
          month = 1;
          year++;
      }
      if (month < 10) {
          month = '0' + month
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + '-' + month + '-' + '01';
      var lastDate = year + '-' + month + '-' + monthLastDay;
      if (date === undefined) {
        return ''
      }
      return moment(firstDate).format('YYYY-MM-DD') + ' ~ ' + moment(lastDate).format('YYYY-MM-DD')
    },
    handleSizeChange(val) {
        this.initDetail({pageSize: val})
      },
      handleCurrentChange(val) {
        this.initDetail({pageIndex: val})
      },
    async initDetail (params) {
      this.vLoading = true
      let id = this.options.id || ''
      if (!id) return
      let res = await queryDetailList({
        id: id,
        pageIndex: 1,
        pageSize: 10,
        ...params
      })
      const {data, code, msg} = res
      if (code !== 200)  {
        this.$message.error(msg)
        this.vLoading = false
        return
      }
      if (!data.records.length) return this.vLoading = false
      this.tableData = data.records
      this.pagination = {
          pageIndex: data.current,
          pageSize: data.size,
          total: Number(data.total)
        }
      this.vLoading = false
    }
  },
}
</script>

<style scoped>

</style>
